import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=c8aaa7ae&scoped=true&"
import script from "./footerNav.vue?vue&type=script&lang=js&"
export * from "./footerNav.vue?vue&type=script&lang=js&"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=c8aaa7ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8aaa7ae",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/toutiao/footerNav.vue
// module id = null
// module chunks = 